module.exports = __webpack_public_path__ + "img/border6.0413ce6b.png";